const focusLazy = (el) => {
  setTimeout(() => {
    el?.focus();
  });
};

export { focusLazy };
//# sourceMappingURL=focus.mjs.map
